<template>
  <div class="flex column">
    <img
      style="width: 150px; margin: 0 auto 0;"
      src="https://res.cloudinary.com/helloguest/image/upload/v1587637638/Image_from_iOS.jpg"
    />
    <h4 style="text-align: center; margin-top: 0;" class="heading">HiHello</h4>
    <hr style="width: 250px;"/>
    <p
      class="mb4 mt2 mx2 gray"
      style="text-align: center"
    >{{ $t("cms.coupon.RedeemPopupText") }}</p>
  </div>
</template>

<script>
export default {
  name: 'RedeemModal',
  props: {
    coupon: { type: Object, required: true },
  },
};
</script>
